// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1tRxr","dragIcon":"Choice_dragIcon__3Tyau","left":"Choice_left__13glU","input":"Choice_input__qFY2h"};